import { useDashboardModel } from '../../../modelos/Dashboard/modeloDashboard';
import React, { useEffect, useState, useMemo } from 'react';
import { ChevronDown, ChevronUp, Calendar, FileWarning, User, DollarSign, BookOpen, FileText, Eye } from 'lucide-react'; // Íconos para un mejor UI
import { useConfiguracion } from '../../../metodos/ConfiguracionContext';
import { formatearPrecio } from '../../../utils/utils';
import { useNavigate } from 'react-router-dom';

//estadisticas de solicitudes
const EstadisticasSolicitudesCard = () => (
  <div className="bg-white rounded-xl shadow-lg p-6 h-96">
    <h2 className="text-xl font-bold text-gray-900 mb-4">Estadísticas de Solicitudes</h2>
    <p className="text-gray-500">Aquí irán las gráficas y métricas de solicitudes...</p>
  </div>
);

//PROUNAD
const EstadisticasProUnadCard = ({estadisticasProUnad,LoadingestadisticasProUnad,errorestadisticasProUnad}) => {
  const [clienteExpandido, setClienteExpandido] = useState(null);
  const navigate = useNavigate();

  const todasLasProximasEntregas = useMemo(() => {
    if (!estadisticasProUnad) return [];

    // Usamos flatMap para unir todas las entregas de todos los clientes en un solo array
    return estadisticasProUnad
      .flatMap(cliente =>
        // A cada entrega le añadimos el número de cliente al que pertenece
        cliente.proximasEntregas.map(entrega => ({
          ...entrega,
          numeroCliente: cliente.numeroCliente,
          nombreCliente: cliente.nombreCliente,
        }))
      )
      // Ordenamos por fecha más cercana primero (ascendente)
      .sort((a, b) => new Date(a.fechaEntrega) - new Date(b.fechaEntrega));
  }, [estadisticasProUnad]);

  const handleToggleCliente = (numeroCliente) => {
    // Si se hace clic en el cliente ya abierto, se cierra. Si no, se abre el nuevo.
    setClienteExpandido(prev => (prev === numeroCliente ? null : numeroCliente));
  };

  const handleVerServicio = (servicio) => {
    // Navegar a detalles de solicitud
    navigate(`/contabilidad/detalles_servicio/${servicio.nombreEmpresa}/${servicio.codigo}`);
  };
  

  if (LoadingestadisticasProUnad) return <div className="p-8">Cargando dashboard... ⏳</div>;
  if (errorestadisticasProUnad) return <div className="p-8 text-red-500">Error al cargar el dashboard. ❌</div>;

  return (
    <div className="font-sans">
      <h1 className="text-3xl font-bold text-gray-800 mb-8">Estadisticas plataforma Unad</h1>

      {/* Contenedor principal que apila las filas de widgets */}
      <div className="flex flex-col gap-8">
        
        {/* --- PRIMERA FILA DE WIDGETS --- */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          
          {/* Card de Próximas Entregas (Más pequeño) */}
          <div className="lg:col-span-1 bg-white rounded-xl shadow-lg p-6">
          <h2 className="text-xl font-bold text-gray-900 mb-6 flex items-center">
            <Calendar size={24} className="mr-3 text-indigo-600" /> {/* Icono principal para el título */}
            Próximas Entregas
          </h2>
          <div className="space-y-4 max-h-96 overflow-y-auto pr-2 custom-scrollbar"> {/* Clase para scrollbar */}
            {todasLasProximasEntregas.length > 0 ? (
              todasLasProximasEntregas.map((entrega) => (
                <div key={`${entrega.numeroCliente}-${entrega.codigo}`} className="p-4 bg-gray-50 rounded-lg shadow-sm border border-gray-100 transition duration-200 ease-in-out hover:shadow-md hover:border-indigo-200">
                  <p className="font-bold text-indigo-700 flex items-center text-lg mb-1">
                    <BookOpen size={20} className="mr-2 text-indigo-500" /> {/* Icono para el Código */}
                    {entrega.codigo}
                  </p>
                  <p className="text-sm text-gray-700 flex items-center mt-2">
                    <User size={16} className="mr-2 text-gray-500" />
                    Cliente #{entrega.numeroCliente} - {entrega.nombreCliente}
                  </p>
                  <p className="text-sm text-gray-700 flex items-center mt-1">
                    <FileText size={16} className="mr-2 text-gray-500" /> {/* Icono para el Título del servicio */}
                    {entrega.titulo}
                  </p>
                  <p className="text-sm font-semibold flex items-center mt-2 text-red-600">
                    <Calendar size={16} className="mr-2" /> {/* Icono para la Fecha de Entrega */}
                    {new Date(entrega.fechaEntrega).toLocaleDateString('es-CO', { day: '2-digit', month: 'long', year: 'numeric' })} {/* Incluimos el año */}
                  </p>

                  <div className="mt-4 pt-3 border-t border-gray-200"> {/* Separador y margen superior para el botón */}
                    <button
                      onClick={() => handleVerServicio(entrega)}
                      className="w-full flex items-center justify-center bg-indigo-500 hover:bg-indigo-600 text-white font-medium py-2 px-4 rounded-md transition-colors duration-200 ease-in-out shadow-sm hover:shadow-md focus:outline-none focus:ring-2 focus:ring-indigo-400 focus:ring-opacity-75"
                    >
                      <Eye size={18} className="mr-2" /> {/* Icono de 'Ver' */}
                      Ver Servicio
                    </button>
                  </div>
                </div>
              ))
            ) : (
              <p className="text-sm text-gray-500 p-4 text-center">🎉 No hay entregas pendientes. ¡Buen trabajo!</p>
            )}
          </div>
          </div>

          {/* Card de Lista de Clientes (Más pequeño) */}
          <div className="lg:col-span-2 bg-white rounded-xl shadow-lg p-6">
            <h2 className="text-xl font-bold text-gray-900 mb-4">Resumen de Clientes</h2>
            <div className="space-y-2 max-h-96 overflow-y-auto pr-2"> {/* ALTURA REDUCIDA */}
              {estadisticasProUnad.length > 0 ? (
                estadisticasProUnad.map((cliente) => (
                  <div key={cliente.numeroCliente} className="border rounded-lg">
                    <button onClick={() => handleToggleCliente(cliente.numeroCliente)} className="w-full flex justify-between items-center p-4 text-left">
                      <p className="font-bold">Cliente {cliente.nombreCliente} | <span className="text-green-600">{((cliente.percentPagado || 0) * 100).toFixed(0)}% Pagado</span></p>
                      {clienteExpandido === cliente.numeroCliente ? <ChevronUp /> : <ChevronDown />}
                    </button>
                    {clienteExpandido === cliente.numeroCliente && (
                      <div className="px-4 pb-4 border-t grid grid-cols-2 gap-x-4 gap-y-2 pt-4 text-sm">
                        <p><strong>Numero de cliente:</strong> {cliente.numero}</p>
                        <p><strong>Total a Pagar:</strong> ${formatearPrecio(cliente.pagoTotal)}</p>
                        <p><strong>Total Pagado:</strong> ${formatearPrecio(cliente.pagadoCliente)}</p>
                        <p><strong>Servicios (Semestre):</strong> {cliente.numeroDeServicios}</p>
                        <p><strong>Trabajos Pendientes:</strong> {cliente.numeroTrabajosPendientes}</p>
                        <p><strong>Verificados (Admin):</strong> {cliente.numeroTrabajosCheckeadosAdmin}</p>
                      </div>
                    )}
                  </div>
                ))
              ) : <p className="text-sm text-gray-500">No se encontraron clientes.</p>}
            </div>
          </div>
        </div>

        {/* --- SEGUNDA FILA DE WIDGETS --- */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
         
        </div>
        
        {/* Puedes añadir una tercera fila aquí si lo necesitas */}

      </div>
    </div>
  );

};

//Estadisticas de tesis
const EstadisticasTesis = () => (
  <div className="bg-white rounded-xl shadow-lg p-6 h-96">
    <h2 className="text-xl font-bold text-gray-900 mb-4">Estadísticas Generales contabilidad</h2>
    <p className="text-gray-500">Aquí irán otras estadísticas generales de ProUnad...</p>
  </div>
);

//ESTADISTICAS TRABAJOS NO ENTREGADOS
const EstadisticasTrabajosNoEntregados = ({ estadisticasTrabajosNoEntregados, LoadingestadisticasTrabajosNoEntregados, errorestadisticasTrabajosNoEntregados }) => {

  // 2. Ordena los datos por el valor del balancePago de mayor a menor
  const trabajosOrdenados = useMemo(() => {
    if (!estadisticasTrabajosNoEntregados) return [];
    return [...estadisticasTrabajosNoEntregados].sort((a, b) => b.balancePago - a.balancePago);
  }, [estadisticasTrabajosNoEntregados]);

  if (LoadingestadisticasTrabajosNoEntregados) return <div className="bg-white rounded-xl shadow-lg p-6 h-96 flex items-center justify-center">Cargando trabajos... ⏳</div>;
  if (errorestadisticasTrabajosNoEntregados) return <div className="bg-white rounded-xl shadow-lg p-6 h-96 flex items-center justify-center text-red-500">Error al cargar datos. ❌</div>;
  return (
    <div className="bg-white rounded-xl shadow-lg p-6 h-96 flex flex-col">
      <h2 className="text-xl font-bold text-gray-900 mb-2">Trabajos Vencidos No Entregados</h2>
      Ajuste, de fecha de entrega, mostrar fechas y llevar al servicio
      <p className="text-sm text-gray-500 mb-4">Total: {trabajosOrdenados.length}</p>
      
      {/* Contenedor de la lista con scroll */}
      <div className="flex-grow overflow-y-auto pr-2 space-y-3">
        {trabajosOrdenados.length > 0 ? (
          // 3. Renderiza la lista ordenada
          trabajosOrdenados.map((trabajo) => (
            <div key={trabajo.codigo} className="flex justify-between items-center bg-gray-50 p-3 rounded-lg">
              <p className="flex items-center text-gray-700 font-medium">
                <FileWarning size={16} className="mr-2 text-orange-500" />
                {trabajo.codigo}
              </p>
              <p className="flex items-center text-gray-800 font-semibold">
                <DollarSign size={16} className="mr-1 text-green-600" />
                {formatearPrecio(trabajo.balancePago)}
              </p>
            </div>
          ))
        ) : (
          <div className="h-full flex items-center justify-center text-gray-500">
            <p>¡Excelente! No hay trabajos vencidos sin entregar.</p>
          </div>
        )}
      </div>
    </div>
  );
}
  
//Estadisticas de pagos de clientes pendientes
//IDENTIFICAR CLIENTES UNAD
const EstadisticasPagosPendientesClientes = ({ estadistigasPagosPendientes, LoadingestadistigasPagosPendientes, errorestadistigasPagosPendientes }) => {

  // 1. Estado para controlar qué cliente está expandido
  const [clienteExpandido, setClienteExpandido] = useState(null);

  const clientesOrdenados = useMemo(() => {
    if (!estadistigasPagosPendientes) return [];
    // La data que pasaste ya tiene 'totalDeuda', así que esto funciona perfecto.
    return [...estadistigasPagosPendientes].sort((a, b) => b.totalDeuda - a.totalDeuda);
  }, [estadistigasPagosPendientes]);

  // 2. Función para manejar el clic y expandir/colapsar
  const handleToggleCliente = (clienteId) => {
    // Si se hace clic en el cliente ya abierto, se cierra (null). Si no, se abre el nuevo.
    setClienteExpandido(prevId => (prevId === clienteId ? null : clienteId));
  };

  if (LoadingestadistigasPagosPendientes) return <div className="bg-white rounded-xl shadow-lg p-6 h-96 flex items-center justify-center">Cargando saldos... ⏳</div>;
  if (errorestadistigasPagosPendientes) return <div className="bg-white rounded-xl shadow-lg p-6 h-96 flex items-center justify-center text-red-500">Error al cargar los saldos. ❌</div>;

  return (
    <div className="bg-white rounded-xl shadow-lg p-6 h-96 flex flex-col">
      <h2 className="text-xl font-bold text-gray-900 mb-4">Clientes con Pagos Pendientes</h2>
      <p className="text-sm text-gray-500 mb-4">Total: {estadistigasPagosPendientes.length}</p>

      <div className="flex-grow overflow-y-auto pr-2 space-y-3">
        {clientesOrdenados && clientesOrdenados.length > 0 ? (
          clientesOrdenados.map((item) => (
            // 3. Estructura de Acordeón Desplegable
            <div key={item.cliente} className="bg-gray-50 rounded-lg border">
              <button
                onClick={() => handleToggleCliente(item.cliente)}
                className="w-full flex justify-between items-center p-3 text-left"
              >
                <p className="flex items-center text-gray-700 font-medium">
                  <User size={16} className="mr-2 text-gray-500" />
                  {item.cliente}
                </p>
                <div className="flex items-center">
                  <p className="flex items-center text-red-600 font-bold mr-4">
                    <DollarSign size={16} className="mr-1" />
                    {formatearPrecio(item.totalDeuda)}
                  </p>
                  {clienteExpandido === item.cliente ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                </div>
              </button>

              {/* Contenido que se muestra u oculta */}
              {clienteExpandido === item.cliente && (
                <div className="px-4 pb-3 border-t border-gray-200">
                  {item.cliente}
                  <h4 className="text-sm font-bold text-gray-600 my-2">Servicios con Deuda:</h4>
                  <div className="space-y-2">
                    {/* 4. Mapeo de la lista de servicios con deuda */}
                    {item.serviciosConDeuda.map(servicio => (
                      <div key={servicio.codigo} className="flex justify-between text-sm">
                        <span className="text-gray-600">{servicio.codigo}</span>
                        <span className="font-medium text-red-500">{formatearPrecio(servicio.deuda)}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))
        ) : (
          <div className="h-full flex items-center justify-center text-gray-500">
            <p>🎉 No hay clientes con saldos pendientes.</p>
          </div>
        )}
      </div>
    </div>
  );
};

//Modulo que integra todo
const ModuloDashboard = () => {
  const {
      //dashboard proUNAD
        estadisticasProUnad,
        LoadingestadisticasProUnad,
        errorestadisticasProUnad,
        cargarEstadisticasProUnad,

        //trabajos no entregados
        estadisticasTrabajosNoEntregados,
        LoadingestadisticasTrabajosNoEntregados,
        errorestadisticasTrabajosNoEntregados,
        cargarEstadisticasServiciosNoEntregados,

        //pagos
        estadistigasPagosPendientes,
        LoadingestadistigasPagosPendientes,
        errorestadistigasPagosPendientes,
        cargarEstadisticasPagosPendientes,
  } = useDashboardModel();

  const {configuracion} = useConfiguracion();


  useEffect(() =>{
    cargarEstadisticasProUnad(configuracion.nombreEmpresa,"2025-2");
    cargarEstadisticasServiciosNoEntregados(configuracion.nombreEmpresa);
    cargarEstadisticasPagosPendientes(configuracion.nombreEmpresa);
  },[]);

  return (
    <div className="p-4 md:p-8 bg-gray-100 min-h-screen font-sans">
      <h1 className="text-3xl font-bold text-gray-800 mb-8">Dashboard</h1>

      {/* 🧱 CONTENEDOR PRINCIPAL DEL GRID */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">

        <EstadisticasTrabajosNoEntregados
          estadisticasTrabajosNoEntregados={estadisticasTrabajosNoEntregados}
          LoadingestadisticasTrabajosNoEntregados={LoadingestadisticasTrabajosNoEntregados}
          errorestadisticasTrabajosNoEntregados={errorestadisticasTrabajosNoEntregados}
        />

        <EstadisticasPagosPendientesClientes
          estadistigasPagosPendientes={estadistigasPagosPendientes}
          LoadingestadistigasPagosPendientes={LoadingestadistigasPagosPendientes}
          errorestadistigasPagosPendientes={errorestadistigasPagosPendientes}
        />

        <div className="md:col-span-2">
          <EstadisticasProUnadCard
            estadisticasProUnad={estadisticasProUnad}
            LoadingestadisticasProUnad={LoadingestadisticasProUnad}
            errorestadisticasProUnad={errorestadisticasProUnad}
          />
        </div>

      </div>
    </div>
  );



}

export default ModuloDashboard
